import * as React from "react";
import helpHero from "./help-hero.svg";
import styles from "./styles.module.scss";

export const Healthcheck = () => {
  return (
    <div className={styles.healthcheckContainer}>
      <div className={styles.healthcheckContent}>
        <img
          src={helpHero}
          alt="imagem de status"
          className={styles.healthcheckImage}
        />

        <h1 className={styles.healthcheckTitle}>Tudo certo por aqui!</h1>
        <h2 className={styles.healthcheckSubtitle}>
          O serviço está funcionando normalmente.
        </h2>
      </div>
    </div>
  );
};
